import CallHistoryRowLoadingComponent from './CallHistoryRowLoading.component';

export default CallHistoryRowLoadingComponent;
